export default class DocumentDataRecipientRepository {
  ofRecipient(recipientId, clientId) {}

  delete(documentDataId) {}
}
